import SharedEntitiesOverviewItem from "./SharedEntitiesOverviewItem";
export default SharedEntitiesOverviewItem;
